import styled from 'styled-components';
import { boxFlex } from '../../styled';

export const TabsContainer = styled(boxFlex)`
    gap: 8px;
`;

export const NavigationPreWrapper = styled.div`
    margin-bottom: 16px;
    width: 100%;
    overflow: hidden;

    .view-horizontal-navigation {
        margin: 0;
    }
`;
